module.exports = __webpack_public_path__ + "static/media/mercado-register.575f4a65.png";